import app from 'flarum/common/app';

/** What the thresholds count: posts, Leaderboard's points, FoF Gamification's ('votes'), or Money's balance. */

/**
 * A translation key in the ladder's unit: `next` stays `next` for posts and
 * becomes `next_points` for either kind of points. Members are told "points"
 * either way; which extension supplies them only matters to the admin. Money
 * has its own keys, which name the sum with `{amount}`.
 */
export function unit(key, metric) {
  if (!metric || metric === 'posts') return key;
  return metric === 'money' ? `${key}_money` : `${key}_points`;
}

/** A sum in the forum's own money name: "[money] coins" makes "250 coins". */
export function money(value) {
  return (app.forum.attribute('antoinefr-money.moneyname') || '[money]').replace('[money]', String(value));
}
export function ladderApi(method, path, body, options) {
  if (path === void 0) {
    path = '';
  }
  if (options === void 0) {
    options = {};
  }
  return app.request({
    method,
    url: `${app.forum.attribute('apiUrl')}/ladder${path}`,
    body,
    ...options
  });
}

/** "10–24 posts", or "1600+ points" for the top rung. */
export function rangeLabel(prefix, rung, metric) {
  if (metric === 'money') return money(rung.maxPosts === null ? `${rung.minPosts}+` : `${rung.minPosts}–${rung.maxPosts}`);
  return rung.maxPosts === null ? app.translator.trans(`${prefix}.${unit('range_open', metric)}`, {
    min: rung.minPosts
  }) : app.translator.trans(`${prefix}.${unit('range', metric)}`, {
    min: rung.minPosts,
    max: rung.maxPosts
  });
}

/** A member's place on the ladder, as their profile shows it. */
flarum.reg.add('ernestdefoe-ladder', 'common/api', { unit: unit,money: money,ladderApi: ladderApi,rangeLabel: rangeLabel, });